import { Button } from '@workingclock/ui';
import { useTranslation } from 'react-i18next';

import { googlePlayUrl } from '../../lib/env';

/** Google's Play logo, flattened to one colour so it follows the button's text colour. */
function PlayIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden className="h-4 w-4 fill-current">
      <path d="M3.6 1.8a1.5 1.5 0 0 0-.6 1.2v18a1.5 1.5 0 0 0 .6 1.2l10-10.2-10-10.2Zm11.4 9 2.9-2.9L5.5.8l9.5 10Zm0 2.4-9.5 10 12.4-7.1-2.9-2.9Zm6.3-3.6-2.7-1.6-3.1 3.2 3.1 3.2 2.7-1.6a1.8 1.8 0 0 0 0-3.2Z" />
    </svg>
  );
}

export function GooglePlayButton({ className }: { className?: string }) {
  const { t } = useTranslation('marketing');

  return (
    <Button variant="secondary" asChild className={className}>
      <a href={googlePlayUrl} target="_blank" rel="noopener noreferrer">
        <PlayIcon />
        {t('stores.googlePlay')}
      </a>
    </Button>
  );
}
